import { ConfirmationModalComponent } from './../../shared/components/modal/confirmationModal.component';
import { FormularioRegistrarVisitaComponent } from './formulario-registrar-visita.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegistrarVisitaRoutingModule } from './registrar-visita-routing.module';
import { ModalRegistrarVisitaComponent } from './registrar-visita-modal.component';


@NgModule({
    declarations: [FormularioRegistrarVisitaComponent, ModalRegistrarVisitaComponent],
    imports: [
        SharedModule,
        CommonModule,
        RegistrarVisitaRoutingModule
    ],
    exports: [FormularioRegistrarVisitaComponent],
    entryComponents: [ModalRegistrarVisitaComponent, ConfirmationModalComponent]
})
export class RegistrarVisitaModule { }
